// "use client";

// import React, { useEffect, useMemo, useRef, useState } from "react";
// import {
//   collection,
//   getDocs,
//   query,
//   orderBy,
//   startAt,
//   endAt,
//   limit,
//   startAfter,
// } from "firebase/firestore";
// import { db } from "../../../firebase";

// const TITLE_FIELD = "bookName"; // <-- якщо треба: 'name'
// const PAGE_LIMIT = 30;

// export default function ProductPicker({
//   styles,
//   value, // selected product object або null
//   onChange, // (product|null) => void
//   placeholder = "Оберіть книгу…",
// }) {
//   const wrapRef = useRef(null);
//   const listRef = useRef(null);

//   const [open, setOpen] = useState(false);
//   const [input, setInput] = useState("");
//   const [loading, setLoading] = useState(false);

//   const [items, setItems] = useState([]); // results
//   const [lastDoc, setLastDoc] = useState(null);
//   const [hasMore, setHasMore] = useState(true);

//   const [activeIndex, setActiveIndex] = useState(-1);

//   const displayValue = useMemo(() => {
//     if (open) return input;
//     // коли закрито — показуємо вибрану книгу
//     if (value) return value?.bookName || value?.name || "";
//     return "";
//   }, [open, input, value]);

//   // ---- close on outside click
//   useEffect(() => {
//     const onDown = (e) => {
//       if (!wrapRef.current) return;
//       if (!wrapRef.current.contains(e.target)) {
//         setOpen(false);
//         setActiveIndex(-1);
//         // при закритті — очищаємо input, щоб не “залипав” пошук
//         setInput("");
//       }
//     };
//     document.addEventListener("mousedown", onDown);
//     return () => document.removeEventListener("mousedown", onDown);
//   }, []);

//   // ---- load initial page (when open & empty)
//   const loadFirstPage = async () => {
//     setLoading(true);
//     try {
//       const qx = query(
//         collection(db, "product"),
//         orderBy(TITLE_FIELD),
//         limit(PAGE_LIMIT),
//       );
//       const snap = await getDocs(qx);
//       const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
//       setItems(list);
//       setLastDoc(snap.docs[snap.docs.length - 1] || null);
//       setHasMore(snap.docs.length === PAGE_LIMIT);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ---- search by prefix in Firestore (TITLE_FIELD)
//   const runSearch = async (text) => {
//     const qText = String(text || "").trim();
//     setLoading(true);
//     try {
//       if (!qText) {
//         await loadFirstPage();
//         return;
//       }

//       // prefix search: startAt / endAt
//       const qx = query(
//         collection(db, "product"),
//         orderBy(TITLE_FIELD),
//         startAt(qText),
//         endAt(qText + "\uf8ff"),
//         limit(PAGE_LIMIT),
//       );

//       const snap = await getDocs(qx);
//       const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
//       setItems(list);
//       setLastDoc(snap.docs[snap.docs.length - 1] || null);
//       setHasMore(snap.docs.length === PAGE_LIMIT);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ---- debounce search
//   useEffect(() => {
//     if (!open) return;

//     const t = setTimeout(() => {
//       runSearch(input);
//     }, 250);

//     return () => clearTimeout(t);
//   }, [input, open]);

//   // ---- open behavior
//   const openList = async () => {
//     setOpen(true);
//     setActiveIndex(-1);
//     // якщо немає пошуку і список пустий — грузимо першу сторінку
//     if (!items.length && !input) {
//       await loadFirstPage();
//     }
//   };

//   // ---- load more (pagination) when no search or even with search
//   const loadMore = async () => {
//     if (!hasMore || !lastDoc) return;
//     setLoading(true);
//     try {
//       const qText = String(input || "").trim();

//       let qx;
//       if (qText) {
//         qx = query(
//           collection(db, "product"),
//           orderBy(TITLE_FIELD),
//           startAt(qText),
//           endAt(qText + "\uf8ff"),
//           startAfter(lastDoc),
//           limit(PAGE_LIMIT),
//         );
//       } else {
//         qx = query(
//           collection(db, "product"),
//           orderBy(TITLE_FIELD),
//           startAfter(lastDoc),
//           limit(PAGE_LIMIT),
//         );
//       }

//       const snap = await getDocs(qx);
//       const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
//       setItems((prev) => [...prev, ...list]);
//       setLastDoc(snap.docs[snap.docs.length - 1] || lastDoc);
//       setHasMore(snap.docs.length === PAGE_LIMIT);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ---- pick product
//   const pick = (p) => {
//     onChange?.(p || null);
//     setOpen(false);
//     setActiveIndex(-1);
//     setInput("");
//   };

//   // ---- keyboard navigation
//   const onKeyDown = (e) => {
//     if (!open && (e.key === "ArrowDown" || e.key === "Enter")) {
//       e.preventDefault();
//       openList();
//       return;
//     }

//     if (!open) return;

//     if (e.key === "Escape") {
//       e.preventDefault();
//       setOpen(false);
//       setActiveIndex(-1);
//       setInput("");
//       return;
//     }

//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setActiveIndex((i) => Math.min(i + 1, items.length - 1));
//       return;
//     }

//     if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setActiveIndex((i) => Math.max(i - 1, 0));
//       return;
//     }

//     if (e.key === "Enter") {
//       e.preventDefault();
//       if (activeIndex >= 0 && items[activeIndex]) pick(items[activeIndex]);
//     }
//   };

//   // ---- scroll into view for active item
//   useEffect(() => {
//     if (!open) return;
//     if (activeIndex < 0) return;
//     const el = listRef.current?.querySelector?.(`[data-idx="${activeIndex}"]`);
//     if (el && el.scrollIntoView) {
//       el.scrollIntoView({ block: "nearest" });
//     }
//   }, [activeIndex, open]);

//   return (
//     <div className={styles.pickerWrap} ref={wrapRef}>
//       <input
//         className={styles.pickerInput}
//         value={displayValue}
//         placeholder={placeholder}
//         onFocus={openList}
//         onClick={openList}
//         onChange={(e) => {
//           // якщо була вибрана книга — при вводі скидаємо вибір
//           if (value) onChange?.(null);
//           setInput(e.target.value);
//         }}
//         onKeyDown={onKeyDown}
//       />

//       {open && (
//         <div className={styles.pickerPopover}>
//           <div className={styles.pickerHeader}>
//             <span>Книги</span>
//             {loading ? <span>Завантаження…</span> : null}
//           </div>

//           <div className={styles.pickerList} ref={listRef}>
//             {items.length === 0 && !loading && (
//               <div className={styles.pickerEmpty}>Нічого не знайдено</div>
//             )}

//             {items.map((p, idx) => {
//               const title = p?.bookName || p?.name || "Без назви";
//               const author = p?.textAutor
//                 ? Array.isArray(p.textAutor)
//                   ? p.textAutor.join(", ")
//                   : String(p.textAutor)
//                 : "";

//               const isActive = idx === activeIndex;

//               return (
//                 <button
//                   key={p.id}
//                   type="button"
//                   data-idx={idx}
//                   className={`${styles.pickerItem} ${
//                     isActive ? styles.pickerItemActive : ""
//                   }`}
//                   onMouseEnter={() => setActiveIndex(idx)}
//                   onMouseDown={(e) => e.preventDefault()} // щоб не губився фокус
//                   onClick={() => pick(p)}
//                 >
//                   <div className={styles.pickerTitle}>{title}</div>
//                   <div className={styles.pickerMeta}>
//                     {author ? author : `ID: ${p.id}`}
//                   </div>
//                 </button>
//               );
//             })}
//           </div>

//           <div className={styles.pickerFooter}>
//             {hasMore ? (
//               <button
//                 type="button"
//                 className={styles.pickerMoreBtn}
//                 onMouseDown={(e) => e.preventDefault()}
//                 onClick={loadMore}
//                 disabled={loading}
//               >
//                 {loading ? "..." : "Показати ще"}
//               </button>
//             ) : (
//               <span className={styles.pickerHint}>Кінець списку</span>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }
"use client";

import React, { useEffect, useMemo, useRef, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../firebase";

const PAGE_LIMIT = 30;

const normalizeText = (value) =>
  String(value || "")
    .toLowerCase()
    .trim();

export default function ProductPicker({
  styles,
  value, // selected product object або null
  onChange, // (product|null) => void
  placeholder = "Оберіть книгу…",
}) {
  const wrapRef = useRef(null);
  const listRef = useRef(null);

  const [open, setOpen] = useState(false);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);

  const [allItems, setAllItems] = useState([]); // весь список книг
  const [visibleCount, setVisibleCount] = useState(PAGE_LIMIT);
  const [activeIndex, setActiveIndex] = useState(-1);
  const [loadedOnce, setLoadedOnce] = useState(false);

  const displayValue = useMemo(() => {
    if (open) return input;
    if (value) return value?.bookName || value?.name || "";
    return "";
  }, [open, input, value]);

  const loadProducts = async () => {
    if (loadedOnce) return;

    setLoading(true);
    try {
      const snap = await getDocs(collection(db, "product"));
      const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));

      // сортування по назві, щоб список був акуратний
      list.sort((a, b) => {
        const aTitle = normalizeText(a?.bookName || a?.name);
        const bTitle = normalizeText(b?.bookName || b?.name);
        return aTitle.localeCompare(bTitle, "uk");
      });

      setAllItems(list);
      setLoadedOnce(true);
    } catch (error) {
      console.error("ProductPicker load error:", error);
      setAllItems([]);
    } finally {
      setLoading(false);
    }
  };

  // ---- close on outside click
  useEffect(() => {
    const onDown = (e) => {
      if (!wrapRef.current) return;
      if (!wrapRef.current.contains(e.target)) {
        setOpen(false);
        setActiveIndex(-1);
        setInput("");
        setVisibleCount(PAGE_LIMIT);
      }
    };

    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, []);

  const filteredItems = useMemo(() => {
    const q = normalizeText(input);

    if (!q) return allItems;

    return allItems.filter((p) => {
      const title = normalizeText(p?.bookName || p?.name);

      const author = Array.isArray(p?.textAutor)
        ? normalizeText(p.textAutor.join(" "))
        : normalizeText(p?.textAutor);

      return title.includes(q) || author.includes(q);
    });
  }, [allItems, input]);

  const visibleItems = useMemo(() => {
    return filteredItems.slice(0, visibleCount);
  }, [filteredItems, visibleCount]);

  const hasMore = visibleItems.length < filteredItems.length;

  const openList = async () => {
    setOpen(true);
    setActiveIndex(-1);
    await loadProducts();
  };

  const loadMore = () => {
    setVisibleCount((prev) => prev + PAGE_LIMIT);
  };

  const pick = (p) => {
    onChange?.(p || null);
    setOpen(false);
    setActiveIndex(-1);
    setInput("");
    setVisibleCount(PAGE_LIMIT);
  };

  const onKeyDown = async (e) => {
    if (!open && (e.key === "ArrowDown" || e.key === "Enter")) {
      e.preventDefault();
      await openList();
      return;
    }

    if (!open) return;

    if (e.key === "Escape") {
      e.preventDefault();
      setOpen(false);
      setActiveIndex(-1);
      setInput("");
      setVisibleCount(PAGE_LIMIT);
      return;
    }

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setActiveIndex((i) => Math.min(i + 1, visibleItems.length - 1));
      return;
    }

    if (e.key === "ArrowUp") {
      e.preventDefault();
      setActiveIndex((i) => Math.max(i - 1, 0));
      return;
    }

    if (e.key === "Enter") {
      e.preventDefault();
      if (activeIndex >= 0 && visibleItems[activeIndex]) {
        pick(visibleItems[activeIndex]);
      }
    }
  };

  useEffect(() => {
    if (!open) return;
    if (activeIndex < 0) return;

    const el = listRef.current?.querySelector?.(`[data-idx="${activeIndex}"]`);
    if (el?.scrollIntoView) {
      el.scrollIntoView({ block: "nearest" });
    }
  }, [activeIndex, open]);

  return (
    <div className={styles.pickerWrap} ref={wrapRef}>
      <input
        className={styles.pickerInput}
        value={displayValue}
        placeholder={placeholder}
        onFocus={openList}
        onClick={openList}
        onChange={(e) => {
          if (value) onChange?.(null);

          setInput(e.target.value);
          setVisibleCount(PAGE_LIMIT);
          setActiveIndex(-1);
        }}
        onKeyDown={onKeyDown}
      />

      {open && (
        <div className={styles.pickerPopover}>
          <div className={styles.pickerHeader}>
            <span>Книги</span>
            {loading ? <span>Завантаження…</span> : null}
          </div>

          <div className={styles.pickerList} ref={listRef}>
            {!loading && visibleItems.length === 0 && (
              <div className={styles.pickerEmpty}>Нічого не знайдено</div>
            )}

            {visibleItems.map((p, idx) => {
              const title = p?.bookName || p?.name || "Без назви";
              const author = p?.textAutor
                ? Array.isArray(p.textAutor)
                  ? p.textAutor.join(", ")
                  : String(p.textAutor)
                : "";

              const isActive = idx === activeIndex;

              return (
                <button
                  key={p.id}
                  type="button"
                  data-idx={idx}
                  className={`${styles.pickerItem} ${
                    isActive ? styles.pickerItemActive : ""
                  }`}
                  onMouseEnter={() => setActiveIndex(idx)}
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={() => pick(p)}
                >
                  <div className={styles.pickerTitle}>{title}</div>
                  <div className={styles.pickerMeta}>
                    {author ? author : `ID: ${p.id}`}
                  </div>
                </button>
              );
            })}
          </div>

          <div className={styles.pickerFooter}>
            {hasMore ? (
              <button
                type="button"
                className={styles.pickerMoreBtn}
                onMouseDown={(e) => e.preventDefault()}
                onClick={loadMore}
                disabled={loading}
              >
                {loading ? "..." : "Показати ще"}
              </button>
            ) : (
              <span className={styles.pickerHint}>Кінець списку</span>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
